import React from "react";
import { Badge } from '@/components/ui/badge';
import { Layers, Square, LayoutGrid } from 'lucide-react';
import { cn } from '@/lib/utils';

type GroupType = 'single' | 'pair' | 'triple' | null;

interface GroupTypeBadgeProps {
  groupType: GroupType;
  showIcon?: boolean;
  size?: 'sm' | 'default';
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}

export function GroupTypeBadge({ 
  groupType, 
  showIcon = true, 
  size = 'default',
  className,
  onClick 
}: GroupTypeBadgeProps) {
  const sizeClasses = size === 'sm' ? 'text-xs px-1.5 py-0' : '';
  const iconClasses = size === 'sm' ? 'h-2.5 w-2.5 mr-0.5' : 'h-3 w-3 mr-1';
  const cursorClass = onClick ? 'cursor-pointer' : '';

  if (!groupType || groupType === 'single') {
    return (
      <Badge 
        variant="secondary" 
        className={cn(sizeClasses, cursorClass, className)}
        onClick={onClick}
      >
        {showIcon && <Square className={iconClasses} />}
        Single
      </Badge>
    );
  }

  if (groupType === 'pair') {
    return (
      <Badge 
        className={cn(
          'bg-blue-500 hover:bg-blue-600',
          sizeClasses,
          cursorClass,
          className
        )}
        onClick={onClick}
      >
        {showIcon && <Layers className={iconClasses} />}
        Pair
      </Badge>
    );
  }

  if (groupType === 'triple') {
    return (
      <Badge 
        className={cn(
          'bg-purple-500 hover:bg-purple-600',
          sizeClasses,
          cursorClass,
          className
        )}
        onClick={onClick}
      >
        {showIcon && <LayoutGrid className={iconClasses} />}
        Triple
      </Badge>
    );
  }

  return null;
}
